export { default } from './MedicalChart';
